class StoreDelegate {
    setLoading(loading) {
        this.setState((prevState) => {
            return { loading };
        });
    }
}

export default StoreDelegate;
